import React, { useState, useEffect, useMemo } from "react"
import { useParams, Link } from "react-router-dom"
import parse from 'html-react-parser'
import Pagination from '../../pages/paginations'
import ChatComponent from '../../chat/ChatComponent'
import axiosJWT from '../../JwtToken'
import { PreviewPKS } from './PreviewPKS'

function View({ requestCodeProps }) {
    const [msg, setMsg] = useState("")
    const [pesan, setPesan] = useState(false)

    const [currentPage, setCurrentPage] = useState(1)
    const [PageSize] = useState(10)
    const [data, setData] = useState([])

    // Ambil requestCode dari props atau url parameter
    const { codeFromUrl } = useParams()
    const requestCode = requestCodeProps || codeFromUrl

    // State tambahan buat kontrol modal alasan pending dari admin
    const [showModalPending, setShowModalPending] = useState(false)
    const [selectedId, setSelectedId] = useState('')
    const [catatanAdmin, setCatatanAdmin] = useState('')
    const [showModalFile, setShowModalFile] = useState(false)
    const [fileUrl, setFileUrl] = useState("")

    const [showChatDrawer, setShowChatDrawer] = useState(false)
    const [activeRoomCode, setActiveRoomCode] = useState(null)
    const [activeVendorId, setActiveVendorId] = useState('')
    const [activeVendorName, setActiveVendorName] = useState('')
    const [isOpening, setIsOpening] = useState(false)

    // State tambahan buat kontrol modal draf pks
    const [isPKSModalOpen, setIsPKSModalOpen] = useState(false)

    const [rowID, setRowID] = useState(false)
    const [isPksDrafOpen, setIsPksDrafOpen] = useState(false)

    useEffect(() => {
        getData('')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [requestCode])

    const getData = async (key) => {
        try {
            // 🌟 BEDANYA DI SINI: Admin TIDAK mengirim parameter 'user' biar semua penawaran keload,
            // tapi mengirim parameter 'requestCode' untuk memfilter vendor di paket ini saja.
            const response = await axiosJWT.post("/api/request-procurement/load", {
                requestCode: requestCode,
                categoryPage: 'verifikasi',
                key: key,
                jml: 100
            })
            setData(response.data)
            setCurrentPage(1)
        } catch (err) {
            getPesan()
            setMsg(err.response.data.msg ? err.response.data.msg : 'Gagal memproses data, mohon coba lagi!')
        }
    }

    // Aksi Setujui Penawaran (Status '2')
    const handleSetuju = async (id) => {
        try {
            const response = await axiosJWT.put(`/api/request-procurement/approve/${id}`)

            getPesan()
            setMsg(response.data.msg)
            getData('') // Refresh data tabel
            setTimeout(() => {
                getPesan()
                setMsg("")
            }, 2000)
        } catch (err) {
            getPesan()
            setMsg(err.response.data.msg ? err.response.data.msg : 'Gagal memproses data, mohon coba lagi!')
            setTimeout(() => {
                getPesan()
                setMsg("")
            }, 2000)
        }
    }

    const openFile = (url) => {
        setFileUrl(url)
        setShowModalFile(true)
    }

    // Buka Modal Catatan Pending
    const openModalPending = (id) => {
        setSelectedId(id)
        setCatatanAdmin('')
        setShowModalPending(true)
    }

    // Eksekusi Simpan Alasan Pending ke Backend (Status '1')
    const handlePendingSubmit = async () => {
        if (!catatanAdmin.trim()) return alert("Alasan pending wajib diisi!")

        try {
            const response = await axiosJWT.put(`/api/request-procurement/pending-owner/${selectedId}`, {
                notesAdmin: catatanAdmin
            })

            setShowModalPending(false)
            getPesan()
            setMsg(response.data.msg)
            getData('')
            setTimeout(() => {
                getPesan()
                setMsg("")
            }, 2000)
        } catch (err) {
            setShowModalPending(false)
            getPesan()
            setMsg(err.response.data.msg ? err.response.data.msg : 'Gagal memproses data, mohon coba lagi!')
            setTimeout(() => {
                getPesan()
                setMsg("")
            }, 2000)
        }
    }

    const tableData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * PageSize
        const lastPageIndex = firstPageIndex + PageSize
        return !data ? [] : data.slice(firstPageIndex, lastPageIndex)
    }, [data, currentPage, PageSize])

    const getPesan = () => setPesan((prevState) => !prevState)
    const display = { display: `${pesan ? "block" : "none"}` }

    const formatRupiah = (angka) => {
        if (!angka) return "-"
        return new Intl.NumberFormat("id-ID", {
            style: "currency",
            currency: "IDR",
            minimumFractionDigits: 0
        }).format(Number(angka))
    }

    const openChat = async (row) => {
        const targetId = row.createdBy || row.email

        if (!targetId) {
            getPesan()
            setMsg('ID Pengguna tidak valid!')
            setTimeout(() => {
                getPesan()
                setMsg("")
            }, 2000)
            return
        }

        setIsOpening(true)
        try {

            const response = await axiosJWT.post("/api/chat/room", {
                receiverPotensialCode: targetId,
                referenceCode: row.requestCode,
                referenceType: 'PROCUREMENT'
            })

            setActiveVendorId(targetId)
            setActiveRoomCode(response.data.roomCode)
            setActiveVendorName(row.requestTitle || row.profile)
            setShowChatDrawer(true)
        } catch (err) {
            getPesan()
            setMsg('Gagal membuka ruang chat!')
            setTimeout(() => {
                getPesan()
                setMsg("")
            }, 2000)
        } finally {
            setIsOpening(false)
        }
    }

    const getStatusBadge = (status, isPKS = false) => {
        const penawaranMap = {
            '0': { text: 'Verifikasi Baru', class: 'badge-default' },
            '1': { text: 'Pending Penawaran (Butuh Perbaikan)', class: 'badge-warning' },
            '2': { text: 'Penawaran Disetujui', class: 'badge-primary' },
            '3': { text: 'Dibatalkan Vendor', class: 'badge-warning' },
            '4': { text: 'Penawaran Ditolak', class: 'badge-danger' },
            '5': { text: 'Proses PKS', class: 'badge-info' },
            '6': { text: 'PKS Selesai', class: 'badge-success' }
        }

        const pksMap = {
            'Pengajuan': { text: 'Draf PKS: Pengajuan', class: 'badge-info' },
            'Disetujui': { text: 'PKS Disetujui', class: 'badge-success' },
            'Ditolak': { text: 'PKS Ditolak', class: 'badge-danger' }
        }
        const map = isPKS ? pksMap : penawaranMap
        const s = map[status] || { text: isPKS ? status : 'Unknown', class: 'badge-secondary' }

        return (
            <span className={`badge ${s.class} mb-1 d-block`}>
                {s.text}
            </span>
        )
    }

    const openModalPKS = (pksID) => {
        setSelectedId(pksID)
        setCatatanAdmin('')
        setIsPKSModalOpen(true)
    }

    // Eksekusi Simpan Alasan Pending ke Draf PKS (Status 'Ditolak')
    const handleTolakDrafPKS = async () => {
        if (!catatanAdmin.trim()) return alert("Alasan ditolak wajib diisi!")

        try {
            const response = await axiosJWT.put(`/api/pks/reject/${selectedId}`, {
                notesAdmin: catatanAdmin
            })

            setIsPKSModalOpen(false)
            getPesan()
            setMsg(response.data.msg)
            getData('')
            setTimeout(() => {
                getPesan()
                setMsg("")
            }, 2000)
        } catch (err) {
            setIsPKSModalOpen(false)
            getPesan()
            setMsg(err.response.data.msg ? err.response.data.msg : 'Gagal memproses data, mohon coba lagi!')
            setTimeout(() => {
                getPesan()
                setMsg("")
            }, 2000)
        }
    }

    const approvePKS = async (id) => {
        getPesan()
        setMsg('Mohon Tunggu, sedang memproses dokumen...')

        try {
            const response = await axiosJWT.put(`/api/pks/approve/${id}`)

            setMsg(response.data.msg)
            getData('') // Refresh data tabel
            setTimeout(() => {
                getPesan()
                setMsg("")
            }, 2000)
        } catch (err) {
            getPesan()
            setMsg(err.response.data.msg ? err.response.data.msg : 'Gagal memproses data, mohon coba lagi!')
            setTimeout(() => {
                getPesan()
                setMsg("")
            }, 2000)
        }
    }

    const openPKS = (id) => {
        setRowID(id)
        setIsPksDrafOpen(true)
    }

    const closePKS = () => {
        setRowID(null)
        setIsPksDrafOpen(false)
    }

    const displayPKS = {
        display: `${isPksDrafOpen ? "block" : "none"}`
    }

    return (<>
        <div className="container">
            <div className="card animated fadeInUp animation-delay-7 br-2 mb-6">
                <div className="card-header bg-purple d-flex justify-content-between align-items-center p-3 br-2">
                    <h4 className="no-m font-bold color-black">Daftar Penawaran Masuk (Kode: {requestCode})</h4>
                    <Link to={`/akun/kebutuhan-pengadaan`} className="btn btn-danger btn-raised btn-sm br-2" >
                        <i className="fa fa-arrow-left"></i> Kembali
                    </Link>
                </div>
                <div className="card-body p-5">
                    <div className="form-group">
                        <input type="text" className="form-control" placeholder="Cari nama perusahaan / kontak vendor..." onChange={(e) => getData(e.target.value)} />
                    </div>
                    <div className="table-responsive">
                        <table className="table table-nomargin dataTable table-bordered data">
                            <thead>
                                <tr className="purple">
                                    <th>No</th>
                                    <th>Perusahaan / Profil</th>
                                    <th>Kontak Vendor</th>
                                    <th>Berkas</th>
                                    <th>Status Saat Ini</th>
                                    <th>Aksi Admin</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tableData.map((row, i) => (
                                    <tr key={row._id}>
                                        <td width={"5%"}>{i + 1}</td>
                                        <td width={"30%"} className="text-left">
                                            <span className="badge d-inline-block text-wrap badge-success">{row.profile || row.requestFrom}</span>
                                            <h5>{row.requestTitle}</h5>
                                            <small className="text-muted">{row.alamat} Kel. {row.kelurahan} Kec. {row.kecamatan}</small>
                                        </td>
                                        <td width={"25%"} className="text-left">
                                            <b>{row.contactName}</b><br />
                                            <i className="fa fa-phone"></i> {row.phoneNumber}<br />
                                            <i className="fa fa-envelope"></i> {row.email}<br />
                                            <i className="fa fa-money"></i> Rp. {row.nilaiPenawaran ? formatRupiah(row.nilaiPenawaran) : '-'}
                                        </td>
                                        <td width={"10%"} className="text-center">
                                            {row.filePath ? (
                                                <a onClick={() => openFile(row.filePath)} className="btn btn-xs btn-raised btn-danger br-2 mb-1">
                                                    <i className="fa fa-file-pdf-o"></i> Penawaran
                                                </a>
                                            ) : <span className="text-muted small">Belum diunggah</span>}
                                            {parseInt(row.status) >= 5 && (
                                                <>
                                                    {row.statusPKS === 'Disetujui' ? (
                                                        <button type="button" className="btn btn-xs btn-raised btn-danger br-2" onClick={() => openFile(row.pksFile)}>
                                                            <i className="fa fa-file-pdf-o"></i> PKS
                                                        </button>
                                                    ) : (
                                                        <button type="button" className="btn btn-xs btn-raised btn-primary br-2" onClick={() => openPKS(row.pksID)}>
                                                            <i className="fa fa-eye"></i> Draf PKS
                                                        </button>
                                                    )}
                                                </>
                                            )}
                                        </td>
                                        <td width={"15%"} className="text-left">
                                            {/* Badge Penawaran */}
                                            {getStatusBadge(row.status, false)}

                                            {/* Badge PKS (Muncul cuma kalau statusnya sudah proses PKS, yakni > 4) */}
                                            {parseInt(row.status) >= 5 && row.statusPKS && (
                                                getStatusBadge(row.statusPKS, true)
                                            )}

                                            {/* Info Tambahan (Keterangan Revisi/Pending) */}
                                            {row.information && row.information !== 'undefined' && (
                                                <div className="small text-danger font-italic border-top mt-1 pt-1">
                                                    Info: {parse(row.information)}
                                                </div>
                                            )}
                                            {row.notesAdmin && row.notesAdmin !== 'undefined' && (
                                                <div className="label label-danger p-2 mt-2 small mb-0" style={{ borderLeft: '4px solid #d9534f' }}>
                                                    <strong><i className="fa fa-exclamation-triangle"></i> Catatan Koreksi:</strong><br />
                                                    {parse(row.notesAdmin)}
                                                </div>
                                            )}
                                        </td>
                                        <td width={"15%"} className="text-center">
                                            {row.status === '0' || row.status === '1' ? (
                                                <>
                                                    {/* Tombol Aksi Utama */}
                                                    {row.status === '0' ? (
                                                        <>
                                                            <button onClick={() => handleSetuju(row._id)} className="btn btn-raised btn-success btn-sm br-2 m-1">
                                                                <i className="fa fa-check"></i> Setuju
                                                            </button>
                                                            <button onClick={() => openModalPending(row._id)} className="btn btn-raised btn-danger btn-sm br-2 m-1">
                                                                <i className="fa fa-times"></i> Pending
                                                            </button>
                                                        </>
                                                    ) : null}

                                                    {/* Tombol CHAT selalu muncul selama statusnya 0 atau 1 */}
                                                    <button onClick={() => openChat(row)} className="btn btn-raised btn-info btn-sm br-2 m-1">
                                                        {isOpening ? "Memproses..." : <><i className="fa fa-comments"></i> Diskusi</>}
                                                    </button>
                                                </>
                                            ) : null}
                                            {parseInt(row.status) >= 5 ? (
                                                <>
                                                    <span className="badge badge-info">{row.statusPKS || 'Pengajuan'}</span>
                                                    {row.statusPKS === 'Pengajuan' && (<>
                                                        <button onClick={() => approvePKS(row.pksID)} className="btn btn-raised btn-sm btn-success br-2 mt-1">
                                                            <i className="fa fa-check"></i> Setujui PKS
                                                        </button>
                                                        <button onClick={() => openModalPKS(row.pksID)} className="btn btn-raised btn-sm btn-info br-2 mt-1">
                                                            <i className="fa fa-eye"></i> Pending Draf PKS
                                                        </button>
                                                    </>)}
                                                </>
                                            ) : null}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="form-group mt-3">
                        <div className="row">
                            <div className="col-md-2 col-xs-6">Total: <b>{data.length}</b> Rekor</div>
                            <div className="col-md-10 col-xs-6">
                                <Pagination className="pagination-bar text-right" currentPage={currentPage} totalCount={data.length} pageSize={PageSize} onPageChange={page => setCurrentPage(page)} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {showModalFile && (
            <div className="modal-backdrop fade in" style={{ zIndex: 1040 }}></div>
        )}

        {showModalFile && (
            <div className="modal-open">
                <div className="modal modal-primary show" style={{ display: "block", zIndex: 1060 }}>
                    <div className="modal-dialog modal-md">
                        <div className="modal-content br-0">
                            <div className="modal-header bg-primary p-1">
                                <button type="button" className="close no-p" onClick={() => setShowModalFile(false)} style={{ color: '#fff', opacity: 1 }}>&times;</button>
                                <h4 className="modal-title no-p"><i className="fa fa-certificate"></i> Preview File</h4>
                            </div>
                            <div className="modal-body p-0" style={{ height: '50vh', overflow: 'hidden', backgroundColor: '#525659' }}>
                                {fileUrl ? (
                                    <iframe src={`${fileUrl}#toolbar=1&navpanes=0&scrollbar=1`} width="100%" height="100%" frameBorder="0" title="File TJSL"></iframe>
                                ) : (
                                    <div className="p-5 text-center text-white">Memuat dokumen...</div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-default btn-raised br-2" onClick={() => setShowModalFile(false)}>Tutup</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade in" style={{ zIndex: 1055 }}></div>
            </div>
        )}

        {/* DRAWER CHAT ADMIN */}
        {showChatDrawer && (
            <>
                <div className={'chat-canvas'}>
                    <div className="bg-primary p-3 text-white d-flex justify-content-between">
                        <span>Diskusi: {activeVendorName}</span>
                        <button className="btn btn-raised btn-xs btn-danger" onClick={() => setShowChatDrawer(false)}>X</button>
                    </div>
                    <div style={{ height: 'calc(100% - 50px)' }}>
                        {/* PANGGIL KOMPONEN CHAT KITA DI SINI */}
                        <ChatComponent
                            roomCode={activeRoomCode}
                            targetUser={activeVendorId}
                        />
                    </div>
                </div>
                <div className="modal-backdrop fade in" onClick={() => setShowChatDrawer(false)} style={{ zIndex: 1069 }}></div>
            </>
        )}

        {/* MODAL ALASAN PENDING ADMIN */}
        {showModalPending && (
            <>
                <div className="modal show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header bg-primary p-1">
                                <h4 className="modal-title text-center no-p font-bold">KETERANGAN</h4>
                            </div>
                            <div className="modal-body">
                                <div className="form-group">
                                    <label>Tuliskan catatan detail kekurangan berkas:</label>
                                    <textarea className="form-control" rows="4" value={catatanAdmin} onChange={(e) => setCatatanAdmin(e.target.value)} placeholder="Contoh: Berkas [Nama Dokumen] tidak terbaca dengan jelas / masa berlaku sudah habis. Harap melakukan pembaruan dokumen agar permohonan dapat diproses lebih lanjut."></textarea>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary btn-raised br-2" onClick={handlePendingSubmit}>Kirim Alasan</button>
                                <button type="button" className="btn btn-danger btn-raised br-2" onClick={() => setShowModalPending(false)}>Batal</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade in"></div>
            </>
        )}

        {isPksDrafOpen ? (<>
            <div className={isPksDrafOpen ? ("modal-open") : ("")}>
                <div style={displayPKS} className={isPksDrafOpen ? 'modal modal-primary show' : 'modal modal-primary'} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content modal-lg">
                            <div className="modal-header header-modal-primary p-1">
                                <h4 className="modal-title text-center" id="myModalLabel">PKS</h4>
                            </div>
                            <div className="modal-body">
                                <PreviewPKS rowID={rowID} getPesan={getPesan} closePKS={closePKS} setMsg={setMsg} />
                            </div>
                            {/* <div className="modal-footer">
                                <button className="btn btn-default btn-raised br-2" onClick={() => setIsPksDrafOpen(false)}>Tutup</button>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </>) : ("")}

        {/* MODAL ALASAN PENDING ADMIN */}
        {isPKSModalOpen && (
            <>
                <div className="modal show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header bg-primary p-1">
                                <h4 className="modal-title text-center no-p font-bold">DRAF PKS</h4>
                            </div>
                            <div className="modal-body">
                                <div className="form-group">
                                    <label>Tuliskan catatan detail kekurangan draf:</label>
                                    <textarea className="form-control" rows="4" value={catatanAdmin} onChange={(e) => setCatatanAdmin(e.target.value)} placeholder="Contoh: Berkas [Nama Dokumen] tidak terbaca dengan jelas / masa berlaku sudah habis. Harap melakukan pembaruan dokumen agar permohonan dapat diproses lebih lanjut."></textarea>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary btn-raised br-2" onClick={handleTolakDrafPKS}>Kirim Alasan</button>
                                <button type="button" className="btn btn-danger btn-raised br-2" onClick={() => setIsPKSModalOpen(false)}>Batal</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade in"></div>
            </>
        )}

        {/* MODAL PESAN NOTIFIKASI */}
        <div className={pesan ? "modal-open" : ""}>
            <div style={display} className={pesan ? "modal modal-primary show" : "modal modal-primary"} id="myData" tabIndex="-1" role="dialog" aria-hidden="true">
                <div className="modal-dialog center">
                    <div className="modal-content modal-sm">
                        <div className="modal-header header-modal-primary p-1">
                            <h4 className="modal-title text-center no-p font-bold">PESAN</h4>
                        </div>
                        <div className="modal-body text-center">
                            <h4 className="font-bold">{msg.toUpperCase()}</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {pesan ? <div className="modal-backdrop fade in"></div> : ""}
    </>)
}

export default View